const { API_SERVICES } = require('../../general/constants');

function Config() {
  this.localhost = (document.location.hostname === 'localhost');
  this.staging = (document.location.hostname === 'aws-staging.arbitrip.com') ||
      (document.location.hostname === 'staging.letstay.co.il');
  this.research = (document.location.hostname === 'ui-research.arbitrip.com');
  this.sandbox = (document.location.hostname === 'sandbox.arbitrip.com');
  this.demo_server = (document.location.hostname === 'demo.arbitrip.com');
  this.htz = (document.location.hostname === 'htzone.arbitrip.com');
  this.htz_link = 'https://www.htzone.co.il/gotosite/arbitrip/?after=https://api.arbitrip.dev/htzone/login?target=search'
  this.rn = (document.location.hostname === 'railninja.arbitrip.com');
  this.rn_link = 'https://rail.ninja';
  this.prod =
      (document.location.hostname === 'app.arbitrip.com') ||
      (document.location.hostname === 'app-prod.arbitrip.com') ||
      (document.location.hostname === 'secretflights.letstay.co.il') ||
      (document.location.hostname === 'app.letstay.co.il') ||
      this.htz ||
      this.rn;

  this.is_letstay = window.location.hostname.includes('letstay.co.il');

  this.dev_mode = (this.localhost || this.staging || this.research || this.sandbox || this.demo_server);
  this.research_dev_mode = (this.localhost || this.research);
  // research_mode opens some development ui mode to visualize weights to recommendation
  // this.research_mode = true;

  if (this.demo_server) {
      this.api_urls = {
          [API_SERVICES.OPS]: process.env.REACT_APP_API_OPS_URL_DEMO,
          [API_SERVICES.HOTELS]: process.env.REACT_APP_API_HOTELS_URL_DEMO,
      };
  } else if (this.is_letstay) {
    this.api_urls = {
      [API_SERVICES.OPS]: process.env.REACT_APP_API_OPS_URL_LETSTAY,
      [API_SERVICES.HOTELS]: process.env.REACT_APP_API_HOTELS_URL_LETSTAY,
    };
  } else {
      this.api_urls = {
        [API_SERVICES.OPS]: process.env.REACT_APP_API_OPS_URL,
        [API_SERVICES.HOTELS]: process.env.REACT_APP_API_HOTELS_URL
      };
    }

  // Room mapping service api
  this.rms_url = process.env.REACT_APP_RMS_URL;

  this.toggleDevMode = (function () {
    this.dev_mode = !this.dev_mode;
  });

  this.blockDevMode = (function () {
    this.localhost = false;
    this.staging = false;
    this.research = false;
    // this.prod = true;
    this.dev_mode = false;
  });
    
  this.auto_fill = false;
  this.force_auto_fill = (process.env.REACT_APP_FORCE_AUTO_FILL || '').toLowerCase() === 'true';

  this.city_search_limit = 20;
  this.gtmId = process.env.REACT_APP_GTM_ID;
  // Additional GTM IDs for specific domains to share with 3rd party
  this.additionalGTMperDomain = new Map([['htzone.arbitrip.com', 'GTM-52MHJ6D9']]);
}

export default new Config();
